export default "__VITE_ASSET__cw$KyfQV__"